module.exports = __webpack_public_path__ + "static/img/carousel_3_optyeh_ar_4_3_w_1224.2f9257b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_3_optyeh_ar_4_3_w_1224.jpg
// module id = 6hJP
// module chunks = 0